import { ref } from 'vue'

export const sceneRunMode = ref()
export const sceneId = ref()
export const scene = ref()
export const viewSceneMode = ref()
export const scriptEnded = ref()
export const sceneResults = ref()
export const scriptTotalTime = ref()
export const scriptTime = ref()
export const scriptEndTime = ref()
export const scriptCheckpointTimes = ref()
export const scriptTutorialValidating = ref()
export const tutorialValidationResults = ref()
export const score = ref()
export const scoreDecreased = ref()
export const successScore = ref()
export const captions = ref([])
export const invalidScriptReferences = ref([])
export const sceneRunUUID = ref()
